import getRandomlyTranslatedAndZoomedCameraProperties from './getRandomlyTranslatedAndZoomedCameraProperties';

const camera = { getRandomlyTranslatedAndZoomedCameraProperties };

export default camera;
